import { AlphaVCircleIcon } from './AlphaVCircleIcon';

/**
 * author: Contributors
 * id C97A782B-26C7-4732-804F-D7D5BE126D5D
 * name alpha-v-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-v-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterVCircleIcon = AlphaVCircleIcon;
export default LetterVCircleIcon